







































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloContact, getDefaultAloContact } from '@/models/alo/AloContact'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import {DashboardAdmin} from '@/router/pages'
import axios from 'axios'
import FileDownload from 'js-file-download'

@Component({
  name: 'GestionContact'  
})
export default class GestionContact extends Vue {
  private loading = false
  private showError = false    
  private actioning = false
  private newContact = getDefaultAloContact()
  private defaultHeaderHeight = 90
  mounted() {
    this.defaultHeaderHeight = 5
  }

  get tableauHeight(){
    //@ts-ignore
    return this.$store.myGetters.contentHeight - ((this.$refs?.header?.clientHeight+this.defaultHeaderHeight)??this.defaultHeaderHeight)
  }

  private get isAllSelected() {
    return this.contactList.every(p => p.selected)
  }

  private get someSelected() {
    return this.contactList.some(p => p.selected)
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  private headers = [    
    { text: '', value: 'selected', width:30,sortable:false, filterable:false },
    { text: 'Lu', value: 'ctcLu', width:40,sortable:true,filterable:false }, 
    { text: 'Date', value: 'ctcDatadd', width:160  },
    { text: 'Nom / Prénom', value: 'libelle', width:200 },
    { text: 'Activités', value: 'acyIds' },
    { text: '', value:'actions', width:30, sortable:false,filterable:false}
  ]

  private get contactMinDate(){
    return this.$store.myGetters.contactMinDate 
  } 

  private get selectedMonth(){ 
    return this.$store.myGetters.monthContact
  }

  private set selectedMonth(newMonth){
    this.$store.myActions.UI_SET_MONTH_CONTACT(newMonth.toUTCString())
  }

  private get selectedPeriode() {    
    //@ts-ignore
    return this.selectedMonth.getUTCDate() == 31?this.$options.filters.formatDate(this.selectedMonth,"YYYY"):this.$options.filters.formatDate(this.selectedMonth,"MMMM YYYY")
  }  
  
  private get contactList() {
    return this.$store.myGetters.contactList
  }

  private get search(){
    return this.$store.myGetters.searchContact
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_CONTACT(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortContactDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_CONTACT_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortContactBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_CONTACT_BY(value)
  }

    
  created() {
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
    this.$store.myActions.ADM_CONTACT_MIN_DATE_ENSURE()      
  }

  loadContacts(dates:Array<Date>){
    this.loading = true    
    this.$store.myActions.UI_SET_RIGHT_DRAWER_OPEN(false)
    setTimeout(() => {
      this.$store.myActions.ADM_CONTACT_REQUEST(dates).finally(() => {        
        this.loading = false
      })
    }, 
    //@ts-ignore
    this.$vuetify.breakpoint.mobile?200:0);    
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyContact',params:{contactId:item.id}})    
  }

  deleteContact(contact:AloContact) {
     if(contact.id != 0) {      
       this.$confirm(`Voulez vous vraiment supprimer la contact "${contact.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_CONTACT_DELETE_REQUEST(contact.id)
        } 
      })          
    } 
  }

  exportContact(){
    this.actioning = true
     axios({
      url: '/webapi/Contact/execute',
      method: 'PUT',
      data:{
        conIds:this.contactList.filter(c => c.selected).map(c => c.id),
        action:'export'
      },
      responseType: 'blob', // Important
    }).then((response) => {        
        FileDownload(response.data, 'Contacts.xlsx');
    }).finally(()=>{
      this.actioning = false
    });    
  }  

  markAsRead(read:boolean){
    this.actioning = true
    this.$store.myActions.ADM_CONTACT_ACTION_ON_SELECTION_REQUEST({
        conIds:this.contactList.filter(c => c.selected).map(c => c.id),
        action:read?'read':'non-read'
      }).finally(()=>{
      this.actioning = false
    });    
  } 

  toogleSelection(item:AloContact) {
    this.$store.myActions.ADM_CONTACT_SET_SELECTION({selected:!item.selected,ids:[item.id]})
  }

  toogleAllSelection() {
    this.$store.myActions.ADM_CONTACT_SET_SELECTION({selected:!this.isAllSelected,ids:this.contactList.map(p => p.id)})    
  }

  get arianeItems() {
    return  [
        DashboardAdmin,
        {
          text: 'Contacts',
          disabled: true,  
          to: {name:'AdminContact'},        
          exact:true
        }
      ]      
  } 
 
}
